import Homes from "../Components/Homes"

const Index = () => {
    return(
        <Homes />
    )
}

export default Index